import { css } from "@emotion/css";
import { Button, ExternalLink } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { useQuery } from "@octopusdeploy/octopus-react-client";
import { links } from "@octopusdeploy/portal-routes";
import type { FC } from "react";
import { Section } from "~/components/Section/Section";
import ByteSizeFormatter from "~/utils/ByteSizeFormatter/ByteSizeFormatter";
import DateFormatter from "~/utils/DateFormatter";
interface ServerTracesProps {
}
const styles = {
    buttons: css({
        marginLeft: "auto",
        display: "flex",
        gap: space[8],
    }),
};
const ServerTraces: FC<ServerTracesProps> = (props) => {
    const { result: metadata } = useQuery((repository) => repository.OpenTelemetryTraceFileExportConfiguration.getMetadata(), [], "Load trace file metadata");
    return (<div>
            <Section sectionHeader="Server Traces">
                <p>
                    Octopus Server stores recent <ExternalLink href="OpenTelemetryTraceFiles">OpenTelemetry traces</ExternalLink> to help troubleshoot issues. You can download and share these traces with Octopus Support.
                </p>
                {metadata &&
            (metadata.SizeInBytes === 0 ? (<p>No trace files are currently stored.</p>) : (<p>
                            Total storage used: {ByteSizeFormatter(metadata.SizeInBytes)}. {metadata.OldestFileTimestamp && `The oldest trace file was created ${DateFormatter.momentAgo(metadata.OldestFileTimestamp)}.`}
                        </p>))}
            </Section>
            <Section>
                <div className={styles.buttons}>
                    <Button label="Download" href={`bff/open-telemetry-trace-file-export/download`} external isDownload={true} importance="quiet"/>
                    <Button label="Configure" href={links.diagnosticServerTracesPage.generateUrl()} importance="quiet"/>
                </div>
            </Section>
        </div>);
};
ServerTraces.displayName = "ServerTraces";
export default ServerTraces;
